import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "stat-card"
}
const _hoisted_2 = { class: "stat-card__number" }
const _hoisted_3 = { class: "stat-card__label" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SalaryStatCard',
  props: {
    number: {},
    label: {}
  },
  setup(__props: any) {



const numberFormatter = new Intl.NumberFormat('sv-SE');
const formatNumber = (value: number) => numberFormatter.format(value);

return (_ctx: any,_cache: any) => {
  return (__props.number && __props.label)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(formatNumber(__props.number)) + " kr", 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.label), 1 /* TEXT */)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})